module.exports = __webpack_public_path__ + "img/run_event.9588919a.svg";